import { type Control, Controller } from 'react-hook-form';
import { z } from 'zod';

import { DatePicker, type DatePickerProps } from '@/components/controls';

export type FormDatePickerProps = Omit<
  DatePickerProps,
  'value' | 'onChange'
> & {
  control?: Control;
  name: string;
};

export const FormDatePicker = ({
  name,
  control,
  ...props
}: FormDatePickerProps) => {
  return (
    <Controller
      name={name as string}
      control={control}
      defaultValue={null}
      render={({ field: { value, onChange } }) => {
        return <DatePicker {...props} value={value} onChange={onChange} />;
      }}
    />
  );
};

FormDatePicker.displayName = 'Form.DatePicker';

export const required = (message = 'The date is required') => {
  return z
    .union([
      z.instanceof(Date, { message }),
      z.string().refine((str) => !Number.isNaN(Date.parse(str)), { message }),
    ])
    .refine((date) => date !== null, {
      message,
    });
};

FormDatePicker.rules = { required };
